import { ChangeDetectionStrategy, Component, input, output, signal } from "@angular/core";
import { S25LoadingInlineStaticComponent } from "../../modules/s25-loading/s25.loading.inline.static.component";
import { PublisherService } from "../../services/publisher.service";
import { S25IconButtonComponent } from "../s25.icon.button.component";

@Component({
    selector: "s25-ng-publisher-sync-cell",
    template: `
        @if (loading()) {
            <s25-ng-loading-inline-static />
        }
        <s25-ng-icon-button (clicked)="update($event)" type="share2" ariaLabel="Update" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25LoadingInlineStaticComponent, S25IconButtonComponent],
})
export class PublisherSyncCell {
    readonly uid = input.required<number>();
    readonly refreshed = output<void>();

    protected readonly loading = signal(false);

    protected async update(event?: MouseEvent): Promise<void> {
        event?.stopPropagation();
        if (this.loading()) {
            return;
        }
        this.loading.set(true);
        try {
            await PublisherService.updateFeed(this.uid());
            this.refreshed.emit();
        } finally {
            this.loading.set(false);
        }
    }
}
